import { apiCallFailure, successState } from 'app/actions'
import { getStore } from 'store/createStore'

function toMessageText(message) {
  if (!message) {
    return ''
  }

  if (typeof message === 'string' || typeof message === 'number') {
    return message
  }

  if (message._error && message._error.message) {
    return toMessageText(message._error.message)
  }

  if (message.message) {
    return toMessageText(message.message)
  }

  if (message.description) {
    return toMessageText(message.description)
  }

  return '操作失败，请稍后重试'
}

export function showApiSuccess(message = '操作成功!') {
  const store = getStore()
  if (!store) {
    return
  }

  store.dispatch(successState({ message: toMessageText(message) }))
}

export function showApiError(titleOrError = '操作失败，请稍后重试', description) {
  const store = getStore()
  if (!store) {
    return
  }

  if (description !== undefined) {
    store.dispatch(
      apiCallFailure({
        status: 'error',
        title: toMessageText(titleOrError),
        message: toMessageText(description)
      })
    )
    return
  }

  const error =
    typeof titleOrError === 'string' ?
    { status: 'error', message: titleOrError } :
    titleOrError

  store.dispatch(apiCallFailure(error))
}
